import { render, staticRenderFns } from "./SFTPFiles.vue?vue&type=template&id=1c4ab059&scoped=true&"
import script from "./SFTPFiles.vue?vue&type=script&lang=js&"
export * from "./SFTPFiles.vue?vue&type=script&lang=js&"
import style0 from "./SFTPFiles.vue?vue&type=style&index=0&id=1c4ab059&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ab059",
  null
  
)

export default component.exports